/* eslint react-hooks/exhaustive-deps: "warn" */

import { useContext } from 'react';

import { ContentContext } from 'context/ContentContext';

import { useInt } from 'hooks/useInt';

import { Button } from 'ui/atoms/Button/Button';
import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';

import { CaseStudyCard } from 'landing-pages/shared/CaseStudyCard/CaseStudyCard';

import styles from './InPracticeSection.module.scss';

export const InPracticeSection = () => {
  const { secondaryNavigation } = useContext(ContentContext);
  const { t } = useInt();

  return (
    <>
      <CaseStudyCard
        company="Menzies LLP"
        title={t('Menzies LLP: Enhancing CRM With Financial Data via API')}
        summary={t(
          'As a UK accounting and tax advisory firm, Menzies LLP integrates verified financial and registry data directly via API — the same registry-backed identifiers that underpin reliable tax ID and VAT validation.',
        )}
        href="/menzies-llp-enhancing-crm-with-detailed-financial-data-via-api-integration"
      />

      <section className={styles.section}>
        <div className={styles.container}>
          <div className={styles.cta}>
            <TitleBlock
              className={styles.titleBlock}
              align="left"
              title={t('How many of your numbers are still valid?')}
              description={t(
                'Send a sample from your vendor or seller master. We check each EIN and VAT number against the authority that issued it, resolve it to the legal entity in the company register, and return a count of the records where the two no longer agree. No integration, no commitment.',
              )}
            />

            <div className={styles.ctaActions}>
              {secondaryNavigation?.book_demo?.slug && (
                <Button type="dark" size="xl" route={secondaryNavigation.book_demo.slug}>
                  {t('Send us a sample list')}
                </Button>
              )}

              {secondaryNavigation?.free_trial?.slug && (
                <Button type="dark-outline" size="xl" route={secondaryNavigation.free_trial.slug}>
                  {t('Validate your own numbers free')}
                </Button>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
